/*eslint-disable*/
import { CONTENT_TYPE, PAGE } from "../../app/constants";
import { useConfig } from "../../app/context/Config/configContext";
import { useLoginModalContext } from "../../app/context/LoginModal";
import { useTheme } from "../../app/context/Theme";
import {
  getCoinName,
  getLocalisedText,
  isLoggedin,
  replaceCoinWord,
} from "../../app/helpers/helper";
import {
  AccountSettingChangePasswordIcon,
  AccountSettingDeleteAccountIcon,
  AccountSettingLanguageIcon,
  AccountSettingThemeIcon,
} from "../../assets/icons/AccountSettingMenuItemIcons";
import ChevronDownIcon from "../../assets/icons/ChevronDownIcon";
import CoinWalletIcon from "../../assets/icons/CoinWalletIcon";
import LeftArrowIcon from "../../assets/icons/LeftArrowIcon";
import MobileNavMoreIcon from "../../assets/icons/MobileNavMoreIcon";
import ProfileEditTriggerIcon from "../../assets/icons/ProfileEditTriggerIcon";
import ProfileHeaderChevronIcon from "../../assets/icons/ProfileHeaderChevronIcon";
import ProfileHeaderMenuIcon from "../../assets/icons/ProfileHeaderMenuIcon";
import {
  HeaderMenuAccountIcon,
  HeaderMenuContinueWatchingIcon,
  HeaderMenuCoinsIcon,
  HeaderMenuEditProfileIcon,
  HeaderMenuLogoutIcon,
  HeaderMenuSubscriptionIcon,
  HeaderMenuSupportIcon,
  HeaderMenuTimelineIcon,
} from "../../assets/icons/ProfileHeaderMenuItemIcons";
import ProfileLikeChipIcon from "../../assets/icons/ProfileLikeChipIcon";
import RepostIconWhite from "../../assets/icons/RepostIconWhite";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";
import SeriesIcons from "../../assets/icons/SeriesIcons";
import VerifiedProfile from "../../assets/icons/VerifiedProfile";
import ThreeDotIcon from "../../assets/icons/three-dot.svg";
import DefaultProfileImage from "../../assets/img/Profile.png";
import DeleteAccountModal from "../Login-UI/DeleteAccountModal";
import EditIcon from "../VerticalPlayer/Icons/Edit";
import EmptyScreen from "../common/EmptyScreen";
import FollowModal from "../common/FollowModal";
import Loader from "../common/Loader";
import SideFixedPanel, {
  SideFixedPanelHeader,
  SideFixedPanelSection,
} from "../common/SideFixedPanel/SideFixedPanel";
import gluedin from "gluedin-shorts-js";
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LIMIT = 6;
const initialLoadingState = {
  page: false,
  more: false,
};

const STATUS_FILTERS = [
  {
    value: "ACTIVE",
    key: "published",
    labelKey: "label-published",
  },
  {
    value: "PENDING",
    key: "in-progress",
    labelKey: "label-in-progress",
  },
  //   {
  //     value: "DRAFT",
  //     key: "drafts",
  //     labelKey: "label-drafts",
  //   },
];

const pickContentUrlThumbnail = (video: any) => {
  const contentUrls = video?.contentUrls;
  if (!Array.isArray(contentUrls) || contentUrls.length === 0) return undefined;

  const entry =
    contentUrls.find(
      (item: any) => Array.isArray(item?.urls) && item.urls.length > 0,
    ) ||
    contentUrls.find((item: any) => typeof item === "string") ||
    contentUrls[0];

  if (typeof entry === "string") return entry;
  if (Array.isArray(entry?.urls) && entry.urls.length > 0) {
    return entry.urls[0];
  }

  return undefined;
};

const getProfileThumbnailUrl = (video: any) => {
  const direct = video?.thumbnailUrls?.[0] ?? video?.thumbnailUrl;
  if (typeof direct === "string" && direct.length > 0) return direct;
  if (video?.contentType !== "image") return direct;
  return pickContentUrlThumbnail(video);
};

const getProfileContentType = (video: any) =>
  String(video?.type ?? "").toUpperCase();

const formatCompactCount = (count: any) => {
  const value = Number(count ?? 0);
  if (!Number.isFinite(value) || value <= 0) return "0";
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(value >= 10000000 ? 0 : 1)}M`.replace(
      ".0M",
      "M",
    );
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(value >= 10000 ? 0 : 1)}K`.replace(
      ".0K",
      "K",
    );
  }
  return String(value);
};

const extractCoinBalance = (source: any): number | null => {
  const balance = Number(
    source?.data?.result?.balance ??
      source?.data?.result?.coinBalance ??
      source?.data?.result?.coins ??
      source?.coinBalance ??
      source?.coins,
  );
  return Number.isFinite(balance) && balance >= 0 ? balance : null;
};

const getStoredCoinBalance = (): number | null => {
  try {
    const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}");
    const balance = extractCoinBalance(storedUserData);
    return balance;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const syncStoredCoinBalance = (balance: number) => {
  try {
    const storedUserData = JSON.parse(localStorage.getItem("userData") || "{}");
    localStorage.setItem(
      "userData",
      JSON.stringify({
        ...storedUserData,
        coinBalance: balance,
        coins: balance,
      }),
    );
  } catch (error) {
    console.error(error);
  }
};

function MyProfile() {
  const { t, i18n } = useTranslation();
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [isHeaderMenuPanelOpen, setIsHeaderMenuPanelOpen] = useState(false);
  const [isPrimaryHeaderFlow, setIsPrimaryHeaderFlow] = useState(false);
  const navigate = useNavigate();
  const { setShowLoginModal } = useLoginModalContext();
  const [userDetail, setUserDetail]: any = useState(null);
  const [userVideos, setUserVideos]: any = useState([]);
  const [userId, setUserId]: any = useState("");
  const [editProfile, setEditProfile]: any = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [editAccountSetting, setEditAccountSetting] = useState(false);
  const [editMobileSetting, setEditMobileSetting] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [language, setLanguage] = useState(false);
  const [chooseTheme, setChooseTheme] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [showDeleteAccountModal, setDeleteAccountModal] = useState(false);
  const [followModal, setFollowModal] = useState({ show: false, type: "" });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [userMetaData, setUserMetaData]: any = useState();
  const [coinBalance, setCoinBalance] = useState<number | null>(
    getStoredCoinBalance(),
  );
  const { appConfig } = useConfig();
  const coinName = getCoinName(appConfig, String(t("label-coins")));
  const showProfileHeaderActions =
    appConfig?.appEconomy?.coinSettings?.coinPlatformEnabled !== false;
  const coinWalletAriaLabel = replaceCoinWord(
    String(t("label-coins-wallet")),
    coinName,
  );
  const [openActionMenuId, setOpenActionMenuId] = useState<string | null>(null);
  const [deletingPostId, setDeletingPostId] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState("ACTIVE");
  const [isStatusFilterOpen, setIsStatusFilterOpen] = useState(false);
  const statusFilterOptions = STATUS_FILTERS.map((statusOption) => ({
    ...statusOption,
    label: String(t(statusOption.labelKey)),
  }));
  const availableCoinsCount = useMemo(() => {
    if (coinBalance !== null) {
      return coinBalance;
    }

    const detailCoins = extractCoinBalance(userDetail);
    if (detailCoins !== null) {
      return detailCoins;
    }

    return getStoredCoinBalance() ?? 0;
  }, [coinBalance, userDetail]);
  const availableCoinsText = `${t(
    "label-available-coins",
  )}: ${availableCoinsCount}`;
  const selectedStatusOption =
    statusFilterOptions.find(
      (statusOption) => statusOption.value === selectedStatus,
    ) || statusFilterOptions[0];

  const observer = useRef<IntersectionObserver>();
  const [formData, setFormData] = useState({
    fullName: "",
    userName: "",
    description: "",
    profileImageUrl: "",
  });
  const [passwordFormData, setPasswordFormData] = useState({
    oldPassword: "",
    newPassword: "",
    cpassowrd: "",
  });
  const [deleteAccountFormData, setDeleteAccountFormData] = useState({
    password: "",
  });
  const [errors, setErrors]: any = useState({});
  const [success, setSuccess]: any = useState({});
  const [isLoading, setIsLoading] = useState<any>(initialLoadingState);
  const hiddenFileInput: any = React.useRef(null);

  useEffect(() => {
    let userBasicInfo: any = localStorage.getItem("userData");
    if (userBasicInfo && userBasicInfo !== undefined) {
      userBasicInfo = JSON.parse(userBasicInfo);
      setUserId(userBasicInfo.userId);
    }
  }, []);

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (!target?.closest(".profile-content-menu-wrap")) {
        setOpenActionMenuId(null);
      }
      if (!target?.closest(".profile-content-toolbar-filter-wrap")) {
        setIsStatusFilterOpen(false);
      }
    };
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    async function fetchData(userId: string) {
      setIsLoading((prev: any) => ({ ...prev, page: true }));
      try {
        let userModuleObj = new gluedin.GluedInUserModule();
        let userModuleResponse = await userModuleObj.getUserDetails(userId);
        if (userModuleResponse.status === 200) {
          let userInfo = userModuleResponse.data.result;
          setUserDetail(userInfo);
          setFormData({
            fullName: userInfo?.fullName,
            userName: userInfo?.userName,
            description: userInfo?.description,
            profileImageUrl: userInfo?.profileImageUrl,
          });
        }
        setIsLoading(initialLoadingState);
      } catch (error) {
        setIsLoading(initialLoadingState);
        console.error(error);
      }
    }

    async function fetchMetaData(userId: string) {
      try {
        var UserModuleObj = new gluedin.GluedInFeedModule();
        var userMetaData = await UserModuleObj.getMetadata({
          type: "storyOwner",
          ids: [userId],
        });
        if (userMetaData.status === 200) {
          const userResponse = userMetaData.data.result;
          setUserMetaData(userResponse?.storyOwner[0] || []);
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (userId) {
      fetchData(userId);
      fetchMetaData(userId);
    }
  }, [userId]);

  useEffect(() => {
    let isActive = true;

    const fetchCoinBalance = async () => {
      if (!userId) return;

      try {
        const userModuleObj = new gluedin.GluedInUserModule();
        const balanceResponse = await userModuleObj.getUserBalance();
        const balance = extractCoinBalance(balanceResponse);
        if (isActive && balance !== null) {
          setCoinBalance(balance);
          syncStoredCoinBalance(balance);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchCoinBalance();

    return () => {
      isActive = false;
    };
  }, [userId]);

  const lastElementRef = useCallback(
    (node: any) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !isLoading.more) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore, isLoading.more],
  );

  useEffect(() => {
    const loadMoreData = async () => {
      if (!userId) return;
      try {
        const newData = await fetchVideos(page);
        setUserVideos((prevData: any) => {
          const newVideos = newData?.filter(
            (newVideo: any) =>
              !prevData.some(
                (prevVideo: any) => prevVideo.videoId === newVideo.videoId,
              ),
          );
          return [...prevData, ...newVideos];
        });
        if (newData.length === 0 || newData.length < LIMIT) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(initialLoadingState);
      }
    };

    loadMoreData();
  }, [page, selectedStatus, userId]);

  async function fetchVideos(offset: number = 0) {
    setIsLoading({ page: offset === 1, more: offset > 0 });
    try {
      let userModuleObj = new gluedin.GluedInUserModule();
      var userVideoModuleResponse = await userModuleObj.getUserVideoList({
        userId: userId,
        offset: offset,
        limit: LIMIT,
        type: "BOTH",
        status: selectedStatus,
      });
      if (userVideoModuleResponse.status === 200) {
        let videoList = userVideoModuleResponse.data.result;
        return videoList;
      }
      setIsLoading(initialLoadingState);
      return [];
    } catch (error) {
      setIsLoading(initialLoadingState);
      console.error(error);
      return [];
    }
  }

  const toggleMoreOptions = () => {
    setEditMobileSetting(!showMoreOptions);
  };
  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleInputChangeForPassword = (event: any) => {
    const { name, value } = event.target;
    setPasswordFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleInputChangeForDeleteAccountPassword = (event: any) => {
    const { name, value } = event.target;
    setDeleteAccountFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const toggleEditProfilePanel = () => {
    setIsPrimaryHeaderFlow(false);
    setEditProfile(true);
    setShowOverlay(true);
  };

  const handleOpenHeaderMenuPanel = () => {
    setIsPrimaryHeaderFlow(false);
    setIsHeaderMenuPanelOpen(true);
    setShowOverlay(true);
  };

  const handleCloseHeaderMenuPanel = () => {
    setIsPrimaryHeaderFlow(false);
    setIsHeaderMenuPanelOpen(false);
    setShowOverlay(false);
  };

  const handleOpenEditProfileFromHeaderMenu = () => {
    setIsHeaderMenuPanelOpen(false);
    setIsPrimaryHeaderFlow(true);
    setEditProfile(true);
    setShowOverlay(true);
  };

  const handleOpenAccountSettingsFromHeaderMenu = () => {
    setIsHeaderMenuPanelOpen(false);
    setIsPrimaryHeaderFlow(true);
    setEditAccountSetting(true);
    setShowOverlay(true);
  };

  const handleNavigateFromHeaderMenu = () => {
    handleCloseHeaderMenuPanel();
  };

  const handleSignoutFromHeaderMenu = () => {
    handleCloseHeaderMenuPanel();
    userSignout();
  };

  const handleSidePanelOverlayClick = () => {
    if (isHeaderMenuPanelOpen) {
      handleCloseHeaderMenuPanel();
    }
  };

  const handleStoryViewClick = async (
    event: React.MouseEvent<HTMLAnchorElement>,
    href: string,
  ) => {
    event.preventDefault();
    const loggedIn = await isLoggedin();
    if (!loggedIn) {
      setShowLoginModal(true);
      return;
    }
    window.location.assign(href);
  };

  const toggleEditAccountSettingPanel = () => {
    setIsPrimaryHeaderFlow(false);
    setEditAccountSetting(true);
    setShowOverlay(true);
  };

  const reopenPrimaryHeaderMenu = () => {
    setEditProfile(false);
    setEditAccountSetting(false);
    setChangePassword(false);
    setLanguage(false);
    setChooseTheme(false);
    setDeleteAccount(false);
    setIsHeaderMenuPanelOpen(true);
    setShowOverlay(true);
    setIsPrimaryHeaderFlow(false);
  };

  const toggleCloseEditAccountSettingPanel = () => {
    setEditAccountSetting(true);
    setChangePassword(false);
    setLanguage(false);
    setChooseTheme(false);
    setDeleteAccount(false);
  };

  const toggleChangePasswordPanel = () => {
    setChangePassword(true);
    setShowOverlay(true);
  };

  const toggleLanguagePanel = () => {
    setLanguage(true);
    setShowOverlay(true);
  };

  const toggleThemePanel = () => {
    setChooseTheme(true);
    setShowOverlay(true);
  };

  const toggleDeleteAccountPanel = () => {
    setDeleteAccount(true);
    setShowOverlay(true);
  };

  const handleCloseEditProfilePanel = () => {
    if (isPrimaryHeaderFlow) {
      reopenPrimaryHeaderMenu();
      return;
    }
    setEditProfile(false);
    setShowOverlay(false);
  };

  const handleCloseAccountSettingPanel = () => {
    if (isPrimaryHeaderFlow) {
      setEditMobileSetting(false);
      reopenPrimaryHeaderMenu();
      return;
    }
    setEditAccountSetting(false);
    setShowOverlay(false);
    setEditMobileSetting(false);
  };

  const handleCloseChangePasswordPanel = () => {
    if (isPrimaryHeaderFlow) {
      reopenPrimaryHeaderMenu();
      return;
    }
    setEditAccountSetting(false);
    setChangePassword(false);
    setShowOverlay(false);
  };

  const handleCloseLanguagePanel = () => {
    if (isPrimaryHeaderFlow) {
      reopenPrimaryHeaderMenu();
      return;
    }
    setEditAccountSetting(false);
    setLanguage(false);
    setShowOverlay(false);
  };

  const handleCloseThemePanel = () => {
    if (isPrimaryHeaderFlow) {
      reopenPrimaryHeaderMenu();
      return;
    }
    setEditAccountSetting(false);
    setChooseTheme(false);
    setShowOverlay(false);
  };

  const handleCloseSidePanel = () => {
    if (isPrimaryHeaderFlow) {
      reopenPrimaryHeaderMenu();
      return;
    }
    setEditAccountSetting(false);
    setDeleteAccount(false);
    setShowOverlay(false);
  };

  const userSignout = () => {
    localStorage.removeItem("following");
    localStorage.removeItem("userData");
    localStorage.removeItem("userDetails");
    navigate("/sign-in");
  };

  const _logoutUser = () => {
    localStorage.removeItem("following");
    localStorage.removeItem("userData");
    localStorage.removeItem("userDetails");
    navigate("/sign-in");
  };

  const updateProfile = async (updatedFormData?: any) => {
    var userModuleObj = new gluedin.GluedInUserModule();
    try {
      var userModuleResponse = await userModuleObj.editUserProfile(formData);
      if (userModuleResponse?.status === 200) {
        setSuccess({ sucessMessage: "Profile has been updated successfully!" });
        setErrors({});
        setTimeout(() => setSuccess({}), 5000);
      } else {
        setSuccess({});
        setErrors({ errorMessage: userModuleResponse?.data?.statusMessage });
        setTimeout(() => setErrors({}), 5000);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const updatePassword = async () => {
    var userModuleObj = new gluedin.GluedInUserModule();
    var userModuleResponse = await userModuleObj.changePassword(
      passwordFormData,
    );
    if (userModuleResponse.status === 200) {
      setPasswordFormData({ oldPassword: "", newPassword: "", cpassowrd: "" });
      setSuccess({
        sucessMessage: "Your password has been updated successfully!",
      });
      setErrors({});
      setTimeout(() => setSuccess({}), 5000);
    } else {
      setSuccess({});
      setErrors({ errorMessage: userModuleResponse?.data?.statusMessage });
      setTimeout(() => setErrors({}), 5000);
    }
  };

  const handleProfileImageClick = () => {
    hiddenFileInput.current.click();
  };
  const handleFileUploadChange = async (event: any) => {
    const fileUploaded = event.target.files[0];
    let toBase64String = await toBase64(fileUploaded);
    var userModuleObj = new gluedin.GluedInUserModule();
    var userModuleResponse = await userModuleObj.editUserProfileImage({
      baseString64: toBase64String,
    });
    if (
      userModuleResponse.status === 200 ||
      userModuleResponse.status === 201
    ) {
      const updatedImageUrl = userModuleResponse?.data?.result?.imageUrl;
      setFormData((prevFormData) => {
        const updatedFormData = {
          ...prevFormData,
          profileImageUrl: updatedImageUrl,
        };

        // Call updateProfile with updatedFormData to ensure latest state is used
        updateProfile(updatedFormData);
        return updatedFormData;
      });
      setUserDetail((prevUserDetail: any) => ({
        ...prevUserDetail,
        profileImageUrl: updatedImageUrl,
      }));
    } else {
      console.log("Something went wrong, please try again");
    }
  };

  const toBase64 = (file: any): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const getVideoKey = (video: any) => video?.videoId ?? video?._id ?? video?.id;
  const displayableUserVideos = (userVideos || []).filter(
    (video: any) =>
      video?.contentType === "video" || video?.contentType === "image",
  );

  const handleContentDetail = (contentInfo: any) => {
    const clickedId = getVideoKey(contentInfo);
    const index = userVideos?.findIndex(
      (item: any) => getVideoKey(item) === clickedId,
    );
    const offset = index >= 0 ? Math.floor(index / LIMIT) + 1 : 1;

    const contentType = String(contentInfo?.type ?? "").toUpperCase();
    const seriesId = contentInfo?.series?.seriesId ?? contentInfo?.seriesId;
    if (contentType === "EPISODE" && seriesId) {
      const params = new URLSearchParams({
        offset: String(offset),
        contentType: String(CONTENT_TYPE.SERIES),
      });
      if (clickedId) {
        params.set("onScreenElementId", String(clickedId));
      }
      navigate(`/series/${seriesId}?${params.toString()}`);
      return;
    }

    navigate(
      `/content/${userId}?contentType=${CONTENT_TYPE.PROFILE}&clickedVideoId=${clickedId}&offset=${offset}&limit=${LIMIT}`,
    );
  };

  const handleDeleteAccountSubmit = async (event: any) => {
    event.preventDefault();
    try {
      var email = JSON.parse(localStorage.getItem("userData") || "{}")?.email;
      const authLoginInput = new gluedin.GluedInAuthModule();
      const signInRawData = {
        email: email,
        password: deleteAccountFormData?.password,
        deviceId: "23424dsffsf",
        deviceType: "android",
      };
      const userSignInResponse = await authLoginInput.AuthRawData(
        signInRawData,
      );
      if (userSignInResponse.status === 200) {
        setDeleteAccountModal(true);
      } else {
        deleteAccountFormData.password = "";
        setErrors({
          passwordErrorMessage: userSignInResponse?.data?.statusMessage,
        });
        setTimeout(() => setErrors({}), 5000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleConfirmDeleteAccount = async () => {
    const userModuleObj = new gluedin.GluedInUserModule();
    const deleteProfile = await userModuleObj.deleteUserProfile();
    if (deleteProfile.status === 200) {
      userSignout();
    }
  };

  const handleCloseDeleteAccountModal = () => {
    setDeleteAccountModal(false);
  };

  const handleDeletePost = async (video: any) => {
    const postId = getVideoKey(video);
    if (!postId) return;
    const resolvedPostId = String(postId);
    if (deletingPostId === resolvedPostId) return;

    try {
      setDeletingPostId(resolvedPostId);
      const videosModuleObj = new gluedin.GluedInVideosModule();
      const deleteResponse = await videosModuleObj.deletePostById(
        resolvedPostId,
      );
      if (deleteResponse?.status === 200 || deleteResponse?.status === 201) {
        setUserVideos((prevData: any) =>
          prevData.filter(
            (item: any) => String(getVideoKey(item)) !== resolvedPostId,
          ),
        );
        setUserDetail((prevUserDetail: any) => {
          if (!prevUserDetail) return prevUserDetail;
          const currentCount = Number(prevUserDetail?.videoCount ?? 0);
          return {
            ...prevUserDetail,
            videoCount: Math.max(currentCount - 1, 0),
          };
        });
      }
    } catch (error) {
      console.error("Error deleting post:", error);
    } finally {
      setDeletingPostId(null);
      setOpenActionMenuId(null);
    }
  };

  const handleStatusFilterSelect = (status: string) => {
    if (status === selectedStatus) {
      setIsStatusFilterOpen(false);
      return;
    }
    setSelectedStatus(status);
    setUserVideos([]);
    setHasMore(true);
    setPage(1);
    setOpenActionMenuId(null);
    setIsStatusFilterOpen(false);
  };

  const changeLanguage = (language: any) => {
    setIsLoading((prev: any) => !prev);
    i18n.changeLanguage(language);
    localStorage.setItem("defaultLanguage", language);
    setSelectedLanguage(language);
    const targetElement = document.getElementById("direction");
    if (targetElement) {
      targetElement.setAttribute("dir", i18n.dir());
    }
    setEditAccountSetting(false);
    setLanguage(false);
    setShowOverlay(false);
    setIsLoading(initialLoadingState);
  };

  const buildBackHeaderTitle = (
    label: React.ReactNode,
    onBackClick: () => void = toggleCloseEditAccountSettingPanel,
  ) => (
    <>
      <button type="button" className="act-stng-bckbtn" onClick={onBackClick}>
        <LeftArrowIcon />
      </button>
      {label}
    </>
  );

  const headerMenuPanelContent = (
    <nav
      className="profile-header-menu-nav"
      aria-label={String(t("text-more"))}
    >
      <section className="profile-header-menu-group">
        <h5 className="profile-header-menu-group-title">
          {t("text-account-section")}
        </h5>
        <ul className="drop-menu profile-header-menu-list">
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action coin-summary"
              onClick={() => navigate("/coin-wallet")}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuCoinsIcon />
                </span>
                <span className="profile-header-menu-item-text">
                  <span className="profile-header-menu-item-label">
                    {coinName}
                  </span>
                  <span className="profile-header-menu-item-subtitle">
                    {availableCoinsText}
                  </span>
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
        </ul>
      </section>

      <section className="profile-header-menu-group">
        <h5 className="profile-header-menu-group-title">
          {t("text-quick-access")}
        </h5>
        <ul className="drop-menu profile-header-menu-list">
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action edit-profile"
              onClick={handleOpenEditProfileFromHeaderMenu}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuEditProfileIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-editProfile")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action account-setting"
              onClick={handleOpenAccountSettingsFromHeaderMenu}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuAccountIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-accountSetting")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action activity-timeline"
              onClick={() => {
                handleNavigateFromHeaderMenu();
                navigate("/activity-timeline?tab=like");
              }}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuTimelineIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-timeline")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action activity-timeline"
              onClick={() => {
                handleNavigateFromHeaderMenu();
                navigate("/watchlist");
              }}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuContinueWatchingIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-continue-watching")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action activity-timeline"
              onClick={() => {
                handleNavigateFromHeaderMenu();
                navigate("/support");
              }}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuSupportIcon />
                </span>
                <span className="profile-header-menu-item-label">Support</span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action user-sign-out"
              onClick={handleSignoutFromHeaderMenu}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <HeaderMenuLogoutIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-logout")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <ProfileHeaderChevronIcon />
              </span>
            </button>
          </li>
        </ul>
      </section>
    </nav>
  );

  const editProfilePanelContent = (
    <>
      <div className="panel-profile">
        <div className="img-sec upload-profile-image">
          <img
            src={userDetail?.profileImageUrl || DefaultProfileImage}
            className="profileImage bg-img-02"
            alt=""
          />
          <button
            type="button"
            className="panel-profile-edit-trigger"
            onClick={handleProfileImageClick}
          >
            <EditIcon />
          </button>
        </div>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleFileUploadChange}
          name="profileImage"
          className="uploadProfileImage"
          accept=".jpeg,.jpg,.png"
          style={{ display: "none" }}
        />
      </div>

      <div className="panel-form profile-panel-form">
        {errors.errorMessage && (
          <div className="alert alert-danger" role="alert">
            {errors.errorMessage}
          </div>
        )}
        {success.sucessMessage && (
          <div className="alert alert-success success-alert" role="alert">
            {success.sucessMessage}
          </div>
        )}

        <div className="custom-form-group first-input-box">
          <label>{t("full-name")}*</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleInputChange}
          />
        </div>

        <div className="custom-form-group">
          <label>{t("user-name")}*</label>
          <input
            type="text"
            name="userName"
            value={formData?.userName}
            onChange={handleInputChange}
          />
        </div>

        <div className="custom-form-group">
          <label>{t("label-about")}*</label>
          <textarea
            rows={4}
            name="description"
            value={formData?.description ?? ""}
            onChange={handleInputChange}
          ></textarea>
        </div>
        <input
          type="hidden"
          name="profileImageUrl"
          value={formData?.profileImageUrl}
        />
        <div className="custom-form-group custom-btn-group">
          <input
            type="submit"
            name="submit-profile"
            className="update-profile-info"
            value={t("btn-saveChanges") || ""}
            onClick={updateProfile}
          />
        </div>
      </div>
    </>
  );

  const accountSettingPanelContent = (
    <nav
      className="profile-header-menu-nav"
      aria-label={String(t("text-accountSetting"))}
    >
      <section className="profile-header-menu-group">
        <h5 className="profile-header-menu-group-title">
          {t("text-preferences")}
        </h5>
        <ul className="profile-header-menu-list">
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action change-password"
              onClick={toggleChangePasswordPanel}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <AccountSettingChangePasswordIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-changePassword")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action languages"
              onClick={toggleLanguagePanel}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <AccountSettingLanguageIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-languages")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action languages"
              onClick={toggleThemePanel}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <AccountSettingThemeIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("choose-theme-menu")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <RightArrowIcon />
              </span>
            </button>
          </li>
        </ul>
      </section>
      <section className="profile-header-menu-group">
        <h5 className="profile-header-menu-group-title">
          {t("text-security")}
        </h5>
        <ul className="profile-header-menu-list">
          <li className="profile-header-menu-list-item">
            <button
              type="button"
              className="profile-header-menu-item-action delete-account"
              onClick={toggleDeleteAccountPanel}
            >
              <span className="profile-header-menu-item-main">
                <span
                  className="profile-header-menu-item-icon"
                  aria-hidden="true"
                >
                  <AccountSettingDeleteAccountIcon />
                </span>
                <span className="profile-header-menu-item-label">
                  {t("text-DeleteAccount")}
                </span>
              </span>
              <span className="profile-header-menu-chevron" aria-hidden="true">
                <RightArrowIcon />
              </span>
            </button>
          </li>
        </ul>
      </section>
    </nav>
  );

  const changePasswordPanelContent = (
    <div className="panel-form profile-panel-form">
      {errors.errorMessage && (
        <div className="alert alert-danger" role="alert">
          {errors.errorMessage}
        </div>
      )}
      {success.sucessMessage && (
        <div className="alert alert-success success-alert" role="alert">
          {success.sucessMessage}
        </div>
      )}
      <div className="custom-form-group first-input-box">
        <label>{t("label-current-password")}*</label>
        <input
          type="password"
          name="oldPassword"
          placeholder={t("enter-current-password") || ""}
          value={passwordFormData?.oldPassword}
          onChange={handleInputChangeForPassword}
        />
      </div>

      <div className="custom-form-group">
        <label>{t("label-new-password")}*</label>
        <input
          type="password"
          name="newPassword"
          placeholder={t("enter-new-password") || ""}
          value={passwordFormData?.newPassword}
          onChange={handleInputChangeForPassword}
        />
      </div>

      <div className="custom-form-group">
        <label>{t("label-confirm-password")}*</label>
        <input
          type="password"
          name="cpassowrd"
          placeholder={t("enter-confirm-password") || ""}
          value={passwordFormData?.cpassowrd}
          onChange={handleInputChangeForPassword}
        />
      </div>

      <div className="custom-form-group custom-btn-group">
        <input
          type="submit"
          name=""
          className="update-password"
          value={t("btn-saveChanges") || ""}
          onClick={updatePassword}
        />
      </div>
    </div>
  );

  const languagePanelContent = (
    <div>
      <label className="radio-container">
        English
        <input
          type="radio"
          id="en"
          value="en"
          name="radio"
          checked={selectedLanguage === "en"}
          onChange={(event) => changeLanguage(event.target.value)}
        />
        <span className="checkmark"></span>
      </label>
      <label className="radio-container">
        Arabic
        <input
          type="radio"
          id="ar"
          value="ar"
          name="radio"
          checked={selectedLanguage === "ar"}
          onChange={(event) => changeLanguage(event.target.value)}
        />
        <span className="checkmark"></span>
      </label>
    </div>
  );

  const themePanelContent = (
    <div>
      <label className="radio-container">
        Light
        <input
          type="radio"
          id="light"
          value="light"
          name="theme"
          checked={theme === "light"}
          onChange={toggleTheme}
        />
        <span className="checkmark"></span>
      </label>
      <label className="radio-container">
        Dark
        <input
          type="radio"
          id="dark"
          value="dark"
          name="theme"
          checked={theme === "dark"}
          onChange={toggleTheme}
        />
        <span className="checkmark"></span>
      </label>
    </div>
  );

  const deleteAccountPanelContent = (
    <div className="panel-form profile-panel-form">
      <form action="" method="post" onSubmit={handleDeleteAccountSubmit}>
        {errors.passwordErrorMessage && (
          <div className="alert alert-danger" role="alert">
            {errors.passwordErrorMessage}
          </div>
        )}
        <div className="custom-form-group first-input-box">
          <label>{t("label-password")}*</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder={t("enter-password") || ""}
            required
            value={deleteAccountFormData?.password}
            onChange={handleInputChangeForDeleteAccountPassword}
          />
          <div className="password-error">{t("please-enter-password")}</div>
          <div className="password-incorrect">
            {t("please-enter-correct-password")}.
          </div>
        </div>
        <div className="custom-form-group custom-btn-group">
          <input
            type="submit"
            name=""
            className="delete-account-btn"
            value={t("btn-delete") || ""}
          />
        </div>
      </form>
    </div>
  );

  const sidePanelSections: Array<{
    key: string;
    id?: string;
    className: string;
    isOpen: boolean;
    title?: React.ReactNode;
    onClose: () => void;
    content: React.ReactNode;
  }> = [
    {
      key: "header-menu",
      id: "profile-header-menu-panel",
      className: "profile-header-menu-panel web-view",
      isOpen: isHeaderMenuPanelOpen,
      onClose: handleCloseHeaderMenuPanel,
      content: headerMenuPanelContent,
    },
    {
      key: "edit-profile",
      className: "edit-profile-section",
      isOpen: editProfile,
      title: t("text-editProfile"),
      onClose: handleCloseEditProfilePanel,
      content: editProfilePanelContent,
    },
    {
      key: "account-settings",
      className: "account-setting account-setting-panel",
      isOpen: editAccountSetting,
      title: buildBackHeaderTitle(
        t("text-accountSetting"),
        handleCloseAccountSettingPanel,
      ),
      onClose: handleCloseAccountSettingPanel,
      content: accountSettingPanelContent,
    },
    {
      key: "change-password",
      className: "change-password-section",
      isOpen: changePassword,
      title: buildBackHeaderTitle(t("text-changePassword")),
      onClose: handleCloseChangePasswordPanel,
      content: changePasswordPanelContent,
    },
    {
      key: "language",
      className: "language-section",
      isOpen: language,
      title: buildBackHeaderTitle(t("text-languages")),
      onClose: handleCloseLanguagePanel,
      content: languagePanelContent,
    },
    {
      key: "theme",
      className: "theme-option",
      isOpen: chooseTheme,
      title: buildBackHeaderTitle(t("choose-theme-menu")),
      onClose: handleCloseThemePanel,
      content: themePanelContent,
    },
    {
      key: "delete-account",
      className: "delete-account-section",
      isOpen: deleteAccount,
      title: buildBackHeaderTitle(t("text-DeleteAccount")),
      onClose: handleCloseSidePanel,
      content: deleteAccountPanelContent,
    },
  ];

  if (isLoading.page) return <Loader />;

  return (
    <>
      <div className="mobile-nav">
        <button
          type="button"
          className="mobile-nav-toggle"
          onClick={toggleMoreOptions}
          aria-label={String(t("text-more"))}
        >
          <MobileNavMoreIcon />
        </button>
      </div>
      <SideFixedPanelSection
        className="account-setting"
        isOpen={editMobileSetting}
      >
        <SideFixedPanelHeader
          title={t("text-more")}
          onClose={handleCloseAccountSettingPanel}
        />
        <ul className="drop-menu">
          <li>
            <button
              type="button"
              className="change-password"
              onClick={toggleChangePasswordPanel}
            >
              {t("text-changePassword")}
              <span>
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              className="edit-profile"
              onClick={toggleEditProfilePanel}
            >
              {t("text-editProfile")}
              <span>
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              className="activity-timeline"
              onClick={() => {
                setEditMobileSetting(false);
                navigate("/activity-timeline?tab=like");
              }}
            >
              {t("text-timeline")}
              <span>
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li>
            <button type="button" onClick={toggleLanguagePanel}>
              {t("text-languages")}
              <span>
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={toggleDeleteAccountPanel}
              className="delete-account"
            >
              {t("text-DeleteAccount")}
              <span>
                <RightArrowIcon />
              </span>
            </button>
          </li>
          <li>
            <div className="logout">
              <button
                type="button"
                onClick={_logoutUser}
                className="btn_submit"
              >
                {t("text-logout")}
              </button>
              <span>
                <RightArrowIcon />
              </span>
            </div>
          </li>
        </ul>
      </SideFixedPanelSection>
      <div className="full-box profile-full-box">
        <div className="profile-page-head">
          <ul className="profile-page-head-ul list-none">
            <li className="profile-page-head-avatar">
              <div className="img-sec">
                {userMetaData && userMetaData?.stories?.length > 0 ? (
                  <a
                    href={`story-view/${userMetaData?.userId}?type=${PAGE.PROFILE}`}
                    onClick={(event) =>
                      handleStoryViewClick(
                        event,
                        `story-view/${userMetaData?.userId}?type=${PAGE.PROFILE}`,
                      )
                    }
                  >
                    <img
                      src={userDetail?.profileImageUrl}
                      alt=""
                      style={{
                        borderColor:
                          userMetaData?.stories?.length > 0
                            ? "#0033FF"
                            : "#fff",
                      }}
                    />
                  </a>
                ) : (
                  <img
                    src={userDetail?.profileImageUrl || DefaultProfileImage}
                    id="profileImage"
                    className="bg-img-02 profileImage"
                    alt=""
                  />
                )}

                <button
                  type="button"
                  className="profile-avatar-edit-trigger"
                  onClick={toggleEditProfilePanel}
                  aria-label={String(t("text-editProfile"))}
                >
                  <ProfileEditTriggerIcon />
                </button>
              </div>
            </li>

            <li className="profile-page-head-content">
              <ul className="profile-page-head-content-inner">
                <li className="profile-page-info">
                  <div className="flex items-center gap-2">
                    <h4 id="displayName">
                      {getLocalisedText(userDetail, "fullName")}
                    </h4>
                    {appConfig?.verifiedProfiles?.enabled &&
                      userDetail?.verified && <VerifiedProfile />}
                  </div>

                  <h5 id="userId">{userDetail?.userName}</h5>
                </li>

                <ul className="profile-page-list">
                  <li>
                    <button
                      type="button"
                      className="profile-stat-action"
                      onClick={() => {
                        setFollowModal({ show: true, type: "followers" });
                      }}
                    >
                      <span id="followerCount">
                        {userDetail?.followersCount ?? 0}
                      </span>
                      <div className="font-medium">
                        {t("profile-followers")}
                      </div>
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="profile-stat-action"
                      onClick={() => {
                        setFollowModal({ show: true, type: "following" });
                      }}
                    >
                      <span id="followingCount">
                        {userDetail?.followingCount ?? 0}
                      </span>
                      <div className="font-medium">
                        {t("profile-following")}
                      </div>
                    </button>
                  </li>

                  <li>
                    <span id="videoCount">{userDetail?.videoCount ?? 0}</span>
                    <div className="font-medium">{t("profile-posts")}</div>
                  </li>
                </ul>
              </ul>
              <div className="c-text text-blk mt-t-15" id="userDescription">
                {typeof userDetail?.description === "string" &&
                userDetail.description.trim()
                  ? userDetail.description
                  : getLocalisedText(userDetail, "description")}
              </div>
            </li>
          </ul>
          <div className="profile-page-header">
            {/* {showProfileHeaderActions && (
              <div className="profile-page-header-actions">
                <button
                  type="button"
                  className="profile-page-header-icon profile-page-header-icon--wallet"
                  onClick={() => navigate("/coin-wallet")}
                  aria-label={coinWalletAriaLabel}
                >
                  <CoinWalletIcon />
                </button>
              </div>
            )} */}
            <div className="profile-page-header-dropdown web-view">
              <button
                type="button"
                className="profile-page-header-icon"
                onClick={handleOpenHeaderMenuPanel}
                aria-label={String(t("text-more"))}
                aria-expanded={isHeaderMenuPanelOpen}
                aria-controls="profile-header-menu-panel"
              >
                <ProfileHeaderMenuIcon />
              </button>
            </div>
          </div>
        </div>
        <FollowModal
          show={followModal.show}
          onHide={() => setFollowModal({ show: false, type: "" })}
          type={followModal.type}
          userData={userDetail}
        />
        <div className="profile-content-toolbar">
          <h4 className="profile-content-toolbar-title">
            {t("label-content")}
          </h4>
          <div
            className={`profile-content-toolbar-filter-wrap${
              isStatusFilterOpen ? " is-open" : ""
            }`}
          >
            <button
              type="button"
              className="profile-content-toolbar-filter"
              aria-label={
                selectedStatusOption?.label || String(t("label-published"))
              }
              aria-expanded={isStatusFilterOpen}
              onClick={() => setIsStatusFilterOpen((prevValue) => !prevValue)}
            >
              <span>{selectedStatusOption?.label || t("label-published")}</span>
              <ChevronDownIcon className="profile-content-toolbar-filter-icon" />
            </button>
            {isStatusFilterOpen && (
              <div className="profile-content-toolbar-filter-dropdown">
                {statusFilterOptions.map((statusOption) => (
                  <button
                    key={statusOption.key}
                    type="button"
                    className={`profile-content-toolbar-filter-option${
                      selectedStatus === statusOption.value ? " active" : ""
                    }`}
                    onClick={() => handleStatusFilterSelect(statusOption.value)}
                  >
                    {statusOption.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="inner-box arrival-box profile-videos">
          <div id="tabs-content">
            <div className="tab-content userVideoData" id="tab1">
              {displayableUserVideos.length > 0 ? (
                displayableUserVideos.map((video: any) => {
                  const thumbnailUrl = getProfileThumbnailUrl(video);
                  const videoType = getProfileContentType(video);
                  const clickedId = String(getVideoKey(video) ?? "");
                  const isEpisode = videoType === "EPISODE";
                  const isPost = videoType === "POST";
                  const statusValue = String(
                    video?.status ?? video?.contentStatus ?? "",
                  ).toLowerCase();
                  const isPending = statusValue === "pending";

                  return (
                    <div
                      className="box"
                      key={clickedId || video.videoId}
                      ref={lastElementRef}
                    >
                      <div
                        className={`img-box open-video-detail${
                          isPending ? " pending-upload" : ""
                        }`}
                        id={video.videoId}
                        style={{
                          background: `url(${thumbnailUrl}) center`,
                          borderRadius: "8px",
                          backgroundSize: "cover",
                        }}
                        onClick={
                          isPending
                            ? undefined
                            : () => handleContentDetail(video)
                        }
                        aria-disabled={isPending}
                      >
                        {isEpisode && (
                          <span
                            className="profile-content-type-icon"
                            title="Episode"
                          >
                            <SeriesIcons />
                          </span>
                        )}
                        <span className="profile-content-like-chip">
                          <ProfileLikeChipIcon />
                          <span>{formatCompactCount(video?.likeCount)}</span>
                        </span>
                        {isPost && !isPending && (
                          <div className="profile-content-menu-wrap">
                            <button
                              type="button"
                              className="profile-content-more-chip"
                              onClick={(event) => {
                                event.stopPropagation();
                                setOpenActionMenuId((prevValue) =>
                                  prevValue === clickedId ? null : clickedId,
                                );
                              }}
                              aria-label="Open post menu"
                            >
                              <img src={ThreeDotIcon} alt="" />
                            </button>
                            {openActionMenuId === clickedId && (
                              <div
                                className="profile-content-action-menu"
                                onClick={(event) => event.stopPropagation()}
                              >
                                <button
                                  type="button"
                                  className="profile-content-action-menu-item"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleDeletePost(video);
                                  }}
                                  disabled={deletingPostId === clickedId}
                                >
                                  {deletingPostId === clickedId
                                    ? "Deleting..."
                                    : t("text-delete-post")}
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                        {isPending && (
                          <div className="upload-pending-overlay">
                            <span>{t("text-upload-in-progress")}</span>
                          </div>
                        )}
                      </div>
                      {video?.repost && (
                        <div className="repost">
                          <RepostIconWhite />
                          <span className="repost-count">
                            {video?.repostCount}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <EmptyScreen
                  title={t("label-data-not-found")}
                  fullHeight={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <SideFixedPanel
        showOverlay={showOverlay}
        onOverlayClick={handleSidePanelOverlayClick}
      >
        {sidePanelSections.map((section) => (
          <SideFixedPanelSection
            key={section.key}
            id={section.id}
            className={section.className}
            isOpen={section.isOpen}
          >
            <SideFixedPanelHeader
              title={section.title}
              onClose={section.onClose}
            />
            {section.content}
          </SideFixedPanelSection>
        ))}
      </SideFixedPanel>
      <DeleteAccountModal
        show={showDeleteAccountModal}
        handleClose={handleCloseDeleteAccountModal}
        confirmDelete={handleConfirmDeleteAccount}
      />
    </>
  );
}

export default MyProfile;
